var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topabout__list__right__item"},[_c('router-link',{attrs:{"to":_vm.itemAboutChild.link}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.itemAboutChild.about_title)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }